import type { MediaVariant } from '@blauturquesa/shared/public-view';
import { options, usingEmulators } from '../../firebase/config';

// URL directa d'una foto del bucket públic, sense token: les regles en permeten la lectura a tothom.
// No cal cap crida per obtenir-la (getDownloadURL), i amb el nom versionat la memòria cau és d'un any (§20.5).
const BASE = usingEmulators ? 'http://127.0.0.1:9199' : 'https://firebasestorage.googleapis.com';

export function photoUrl(path: string): string {
  const bucket = options.storageBucket ?? '';
  return `${BASE}/v0/b/${bucket}/o/${encodeURIComponent(path)}?alt=media`;
}

/** `srcset` amb totes les variants (§1, principi 3). */
export function photoSrcSet(variants: readonly MediaVariant[]): string {
  return [...variants].sort((a, b) => a.width - b.width).map((v) => `${photoUrl(v.path)} ${v.width}w`).join(', ');
}

export function photoSrc(variants: readonly MediaVariant[], minWidth: number): string {
  // Com pickVariant (paquet compartit), sense importar-lo: aquest fitxer el carrega la part pública.
  const sorted = [...variants].sort((a, b) => a.width - b.width);
  const v = sorted.find((x) => x.width >= minWidth) ?? sorted[sorted.length - 1];
  return v ? photoUrl(v.path) : '';
}
